module.exports = __webpack_public_path__ + "static/media/DarkCheckBox.94d01811.svg";